"use client";

import * as config from "@/app/config";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import type { PropsWithChildren } from "react";

if (typeof window !== "undefined" && config.POSTHOG_ENABLED) {
  posthog.init(config.POSTHOG_API_KEY, {
    api_host: config.POSTHOG_HOST,
    person_profiles: "identified_only",
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: true,
  });
}

export function PostHogProviderWrapper({ children }: PropsWithChildren) {
  if (!config.POSTHOG_ENABLED) return <>{children}</>;
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
